import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3521e4c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "duty-schedule-container" }
const _hoisted_2 = { class: "calendar-section" }
const _hoisted_3 = { class: "year-nav" }
const _hoisted_4 = {
  key: 0,
  class: "year-picker-popup"
}
const _hoisted_5 = { class: "year-picker-nav" }
const _hoisted_6 = { class: "year-picker-grid" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "months-grid" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "month-label" }
const _hoisted_11 = { class: "weekday-header" }
const _hoisted_12 = { class: "days-grid" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "config-section" }
const _hoisted_15 = { class: "duty-time-config" }
const _hoisted_16 = { class: "config-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-label" }, "* 值班时间", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "time-separator" }, "-", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "change-log-section"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "值班时间变更记录表", -1))
const _hoisted_23 = { class: "data-table" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "开始时间"),
    /*#__PURE__*/_createElementVNode("th", null, "结束时间"),
    /*#__PURE__*/_createElementVNode("th", null, "更新人"),
    /*#__PURE__*/_createElementVNode("th", null, "更新时间")
  ])
], -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "empty-text"
}, "暂无数据", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "pagination-info" }
const _hoisted_29 = {
  key: 1,
  class: "off-duty-config"
}
const _hoisted_30 = { class: "off-duty-select-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "不值班客服", -1))
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "placeholder-text"
}
const _hoisted_34 = { class: "staff-search" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "staff-list" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["checked"]
const _hoisted_39 = {
  key: 0,
  class: "empty-text"
}
const _hoisted_40 = { class: "staff-pagination" }
const _hoisted_41 = { class: "page-info" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "mt16" }
const _hoisted_45 = { class: "data-table" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "客服"),
    /*#__PURE__*/_createElementVNode("th", null, "开始时间"),
    /*#__PURE__*/_createElementVNode("th", null, "结束时间"),
    /*#__PURE__*/_createElementVNode("th", null, "更新人"),
    /*#__PURE__*/_createElementVNode("th", null, "更新时间")
  ])
], -1))
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "empty-text"
}, "暂无数据", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "pagination-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "nav-arrow",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeYear(-1)))
        }, "<"),
        _createElementVNode("span", {
          class: "year-label",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleYearPicker && _ctx.toggleYearPicker(...args)))
        }, _toDisplayString(_ctx.currentYear) + "年", 1),
        _createElementVNode("span", {
          class: "nav-arrow",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeYear(1)))
        }, ">")
      ]),
      (_ctx.showYearPicker)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "nav-arrow",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeYearPickerRange(-12)))
              }, "<"),
              _createElementVNode("span", null, _toDisplayString(_ctx.yearPickerStart) + " - " + _toDisplayString(_ctx.yearPickerStart + 11), 1),
              _createElementVNode("span", {
                class: "nav-arrow",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeYearPickerRange(12)))
              }, ">")
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearPickerList, (y) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: y,
                  class: _normalizeClass(['year-item', { active: y === _ctx.currentYear }]),
                  onClick: ($event: any) => (_ctx.selectYear(y))
                }, _toDisplayString(y), 11, _hoisted_7))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
          return _createElementVNode("div", {
            key: m,
            class: _normalizeClass(['month-cell', { expanded: _ctx.expandedMonth === m }]),
            onClick: ($event: any) => (_ctx.toggleMonth(m))
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(m) + "月", 1),
            (_ctx.expandedMonth === m)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "month-calendar",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (w) => {
                      return (_openBlock(), _createElementBlock("span", { key: w }, _toDisplayString(w), 1))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMonthDays(_ctx.currentYear, m), (day, idx) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: idx,
                        class: _normalizeClass(['day-cell', {
                  empty: day === 0,
                  today: _ctx.isToday(_ctx.currentYear, m, day),
                  selected: _ctx.isSelectedDate(_ctx.currentYear, m, day),
                  'has-off': _ctx.hasOffRecords(_ctx.currentYear, m, day)
                }]),
                        onClick: _withModifiers(($event: any) => (day > 0 && _ctx.onDayClick(_ctx.currentYear, m, day)), ["stop"])
                      }, _toDisplayString(day > 0 ? day : ''), 11, _hoisted_13))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_9)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("input", {
            type: "time",
            value: _ctx.dutyStartTime,
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onDutyStartTimeChange(($event.target as HTMLInputElement).value))),
            class: "time-input",
            placeholder: "开始时间"
          }, null, 40, _hoisted_18),
          _hoisted_19,
          _createElementVNode("input", {
            type: "time",
            value: _ctx.dutyEndTime,
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onDutyEndTimeChange(($event.target as HTMLInputElement).value))),
            class: "time-input",
            placeholder: "结束时间"
          }, null, 40, _hoisted_20),
          _createElementVNode("button", {
            class: "btn-primary",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSaveDutyTime && _ctx.onSaveDutyTime(...args)))
          }, "确认"),
          _createElementVNode("button", {
            class: "btn-info",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleChangeLog && _ctx.toggleChangeLog(...args)))
          }, "日志记录")
        ])
      ]),
      (_ctx.showChangeLog)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("table", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changeLogs, (log, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    _createElementVNode("td", null, _toDisplayString(log.startTime), 1),
                    _createElementVNode("td", null, _toDisplayString(log.endTime), 1),
                    _createElementVNode("td", null, _toDisplayString(log.updateByName), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(log.updateTime)), 1)
                  ]))
                }), 128)),
                (!_ctx.changeLogs || _ctx.changeLogs.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_27))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.changeLogs ? _ctx.changeLogs.length : 0) + " 条", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedDateStr)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.selectedDateStr), 1),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", {
                class: "tag-select-container",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleStaffDropdown && _ctx.toggleStaffDropdown(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEmployees, (emp) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: emp.id,
                    class: "tag-item"
                  }, [
                    _createTextVNode(_toDisplayString(emp.name) + " ", 1),
                    _createElementVNode("span", {
                      class: "tag-close",
                      onClick: _withModifiers(($event: any) => (_ctx.removeEmployee(emp.id)), ["stop"])
                    }, "×", 8, _hoisted_32)
                  ]))
                }), 128)),
                (_ctx.selectedEmployees.length === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "请选择客服"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onSaveOffDuty && _ctx.onSaveOffDuty(...args)))
              }, "确认")
            ]),
            (_ctx.showStaffDropdown)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "staff-dropdown",
                  onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("input", {
                      type: "text",
                      placeholder: "搜索工号或姓名",
                      value: _ctx.staffSearchKeyword,
                      onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onStaffSearch(($event.target as HTMLInputElement).value))),
                      onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                    }, null, 40, _hoisted_35)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableStaff, (staff) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: staff.id,
                        class: _normalizeClass(['staff-option', { selected: _ctx.isStaffSelected(staff.id) }]),
                        onClick: ($event: any) => (_ctx.toggleStaff(staff))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.isStaffSelected(staff.id),
                          onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
                        }, null, 8, _hoisted_38),
                        _createElementVNode("span", null, _toDisplayString(staff.name) + "（" + _toDisplayString(staff.code) + "）", 1)
                      ], 10, _hoisted_37))
                    }), 128)),
                    (!_ctx.availableStaff || _ctx.availableStaff.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, "暂无匹配客服"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, "共 " + _toDisplayString(_ctx.filteredTotal) + " 人", 1),
                    _createElementVNode("button", {
                      disabled: _ctx.employeeCurrentPage <= 1,
                      onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.onEmployeePageChange(_ctx.employeeCurrentPage - 1)), ["stop"]))
                    }, "‹", 8, _hoisted_42),
                    _createElementVNode("span", null, _toDisplayString(_ctx.employeeCurrentPage) + " / " + _toDisplayString(_ctx.employeeTotalPages), 1),
                    _createElementVNode("button", {
                      disabled: _ctx.employeeCurrentPage >= _ctx.employeeTotalPages,
                      onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.onEmployeePageChange(_ctx.employeeCurrentPage + 1)), ["stop"]))
                    }, "›", 8, _hoisted_43)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.selectedDateStr) + "不值班客服时间段", 1),
            _createElementVNode("table", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offRecords, (record, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    _createElementVNode("td", null, _toDisplayString(record.employeeName), 1),
                    _createElementVNode("td", null, _toDisplayString(record.startTime), 1),
                    _createElementVNode("td", null, _toDisplayString(record.endTime), 1),
                    _createElementVNode("td", null, _toDisplayString(record.updateByName), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(record.updateTime)), 1)
                  ]))
                }), 128)),
                (!_ctx.offRecords || _ctx.offRecords.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_47, _hoisted_49))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.offRecords ? _ctx.offRecords.length : 0) + " 条", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}